export default [
  {
    header: 'ClientPortal.SideMenu.Properties',
  },
  {
    title: 'ClientPortal.SideMenu.Earnings',
    route: 'earnings',
    icon: 'Payment',
  },
  {
    title: 'ClientPortal.SideMenu.Properties',
    route: 'properties',
    icon: 'Widget',
  },
  {
    title: 'ClientPortal.SideMenu.Catalogs',
    route: 'catalogs',
    icon: 'Book',
  },
  {
    title: 'ClientPortal.SideMenu.Audiences',
    route: 'audiences',
    icon: 'AvatarGroup',
  },
]
